import { mapActions } from "vuex";

export default {
    methods: mapActions(["authChecker", "setLoadingScreen"]),
    beforeMount(){
        this.authChecker()
    },
    mounted(){
        setTimeout(() => {
            this.setLoadingScreen(false)
        }, 1000)
    }
}
